import React from 'react';
import PropTypes from 'prop-types';

function UpArrow({ active, activeColor, color }) {
  return (
    <path
      d="M164.993 181.382C164.841 181.38 160.599 181.415 158.327 181.558C155.936 181.708 153.595 182 152.053 182.272C150.51 182.543 149.766 182.794 148.837 183.321C147.908 183.849 146.792 184.653 145.908 185.647C145.024 186.642 144.371 187.827 143.989 189.033C143.607 190.239 143.497 191.464 143.552 193.776C143.607 196.088 143.828 199.483 144.19 203.485C144.554 207.486 145.059 212.091 145.446 214.607C145.834 217.122 146.104 217.548 148.407 220.036C150.709 222.523 155.043 227.071 157.725 229.765C160.407 232.46 161.438 233.301 162.235 233.802C163.032 234.304 163.887 234.639 164.993 234.616C166.1 234.591 166.978 234.302 167.75 233.802C168.547 233.301 169.578 232.46 172.26 229.765C174.943 227.071 179.276 222.523 181.579 220.036C183.881 217.548 184.152 217.122 184.54 214.607C184.926 212.091 185.432 207.486 185.795 203.485C186.158 199.483 186.379 196.088 186.435 193.776C186.49 191.464 186.379 190.239 185.997 189.033C185.615 187.827 184.962 186.642 184.078 185.647C183.193 184.653 182.077 183.849 181.149 183.321C180.219 182.794 179.476 182.543 177.933 182.272C176.391 182 174.05 181.708 171.659 181.558C169.386 181.414 165.146 181.38 164.993 181.382Z"
      fill={active ? activeColor : color}
    />
  );
}

UpArrow.propTypes = {
  active: PropTypes.bool,
  activeColor: PropTypes.string,
  color: PropTypes.string,
};

UpArrow.defaultProps = {
  active: false,
  activeColor: '#000000',
  color: '#D7DEE6',
};

export default UpArrow;
